/**
 * 入力形式の定数
 */
export const INPUT_TYPE = {
  TEXT: 'TEXT',
  NUMBER: 'NUMBER',
  CHOICE: 'CHOICE',
} as const

/**
 * 追加できる項目の最大数
 */
export const MAX_FIELDS_COUNT = 20

/**
 * 選択式の選択肢の最大数
 */
export const MAX_FIELD_SELECT_OPTIONS_COUNT = 50